import { render, staticRenderFns } from "./featureTiles.vue?vue&type=template&id=70a65284"
import script from "./featureTiles.vue?vue&type=script&lang=js"
export * from "./featureTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports